import styled from 'styled-components';

export const Title = styled.p`
  ${({ theme }) => theme.fontSize.L18};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.M24};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
`;

export const Body = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.M32};
`;

export const Text = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;
